/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/",
    name: "Inicio",
    slug: "home",
    icon: "HomeIcon"
  },
  {
    url: null,
    name: "Configuración",
    slug: "settings",
    icon: "SettingsIcon",
    submenu: [
      {
        url: "/settings",
        name: "Parámetros",
        slug: "parameters",
        icon: "ListIcon"
      }
    ]
  },
  {
    url: "/catalogs",
    name: "Catálogos",
    slug: "catalogs",
    icon: "FolderIcon",
    submenu: [
      {
        url: "/catalogs/categories",
        name: "Categorías",
        slug: "categories",
        icon: "GridIcon"
      },
      {
        url: "/catalogs/products",
        name: "Productos",
        slug: "products",
        icon: "PackageIcon"
      },
      {
        url: "/catalogs/stores",
        name: "Tiendas",
        slug: "stores",
        icon: "HomeIcon"
      },
      {
        url: "/catalogs/customers",
        name: "Clientes",
        slug: "customers",
        icon: "UsersIcon"
      },
      {
        url: "/catalogs/coupons",
        name: "Cupones",
        slug: "coupons",
        icon: "TagIcon"
      }
    ]
  },
  {
    url: "/home",
    name: "Menú inicio",
    slug: "home",
    icon: "LayoutIcon",
    submenu: [
      {
        url: "/home/showcase",
        name: "Destacados",
        slug: "showcase",
        icon: "GridIcon"
      }
    ]
  },
  {
    url: "/statistics",
    name: "Estadísticas",
    slug: "statistics",
    icon: "BarChartIcon",
    submenu: [
      {
        url: "/statistics/products",
        name: "Producto",
        slug: "productStatistics",
        icon: "BarChart2Icon",
        submenu: [
          {
            url: "/statistics/products/period",
            name: "Período",
            slug: "productSalePeriod",
            icon: "BarChart2Icon"
          }
        ]
      }
    ]
  },
  {
    url: "/orders",
    name: "Órdenes",
    slug: "orders",
    icon: "ShoppingCartIcon"
  }
]
